<cs-quote-banner *ngIf="isCatalogRoute"></cs-quote-banner>
<ng-container *ngIf="screenWidth > 800; else mobileNav">
  <div class="navbar-main">
    <div class="navbar-inner">
    <div class="d-flex align-items-center navbar-left">
      <div class="d-flex align-items-center">
        <ng-container>
          <a class="navbar-brand-img d-flex align-items-center" [href]="rootUrl">
            <img [src]="getLogo()" class="navbar-logo" height="40" width="40" alt="Culture Studio Company Logo" loading="lazy" />
          </a>
        </ng-container>
        <div class="d-flex align-items-center">
          <ul class="navbar-nav flex-row navbar-links">
            <ng-container *ngFor="let nav of navigation">
              <li *ngIf="nav.show" class="nav-item position-relative">
                <span class="badge badge-warning translate-middle badge nav-badge" *ngIf="nav.label?.text?.length > 0" [ngStyle]="{color: nav.label.textColor, background: nav.label.backgroundColor}">{{nav.label.text}}</span>
                <a class="btn shadow-0 nav-link nav-link-sub" routerLinkActive="active" [routerLink]="nav.link"
                  role="button">
                  {{ nav.name }}
                </a>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center navbar-right text-nowrap">

      <ul class="navbar-nav-r">
        <div class="navbar-nav-ul flex-row navbar-nav">
          <ng-container *ngIf="authenticated; else login">
            <span class="rounded-circle bg-secondary p-2 login-avatar d-flex align-items-center">{{ getUserAcronym() }}</span>
            <div mdbDropdown class="d-flex align-items-center">
              <ul class="list-unstyled ms-2" type="button" id="dropdownMenuButton" aria-expanded="false"
                mdbDropdownToggle data-mdb-display="static">
                <li class="nav-name">
                  {{ user.name }}
                </li>
                <li class="nav-name-client">{{ clientName }}
                </li>
              </ul>
              <ul mdbDropdownMenu class="dropdown-menu navbar-user-dropdown dropdown-menu-end"
                aria-labelledby="dropdownMenuLink">
                <li>
                  <ng-container *ngIf="activeDecorator && hasMultipleClients">
                    <a class="dropdown-item" href="/login/choose-client">
                      <i class="fas fa-users-cog pe-1"></i>
                      Change Client
                    </a>
                  </ng-container>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li><a class="dropdown-item" (click)="logout()">
                    <i class="fas fa-sign-out-alt pe-1"></i>
                    Sign out</a></li>
              </ul>
            </div>
            <li class="ms-2 mt-1">
              <i class="fas fa-angle-down"></i>
            </li>
          </ng-container>
        </div>
      </ul>
    </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="screenWidth > 800; else mobileContainer">
    <div class="content-wrapper">
      <content class="col-sm-12 main-height-content">
        <router-outlet></router-outlet>
      </content>
    </div>
</ng-container>

<!-- TEMPLATES -->
<ng-template #mobileNav>
  <div class="row px-2 py-2 navbar-dark navbar-sidenav-mobile navbar-main-mobile overflow-scroll">
    <div class="col-sm-12">
      <mdb-sidenav-layout>
        <mdb-sidenav #sidenav="mdbSidenav">

          <ng-container>
            <a class="ripple drawer-brand" href="/catalog" data-mdb-ripple-color="primary">
              <img [src]="getLogo()" class="navbar-logo" height="36" width="36" alt="Culture Studio Company Logo" loading="lazy" />
            </a>
          </ng-container>

          <div class="drawer-divider"></div>

          <ul class="sidenav-menu overflow-scroll">
              <mdb-sidenave-item *ngFor="let nav of subNavigationCS" class="overflow-scroll">
                <mdb-accordion [flush]="true" *ngIf="nav.link === '/catalog'" class="overflow-scroll drawer-accordion">
                  <mdb-accordion-item class="position-relative">
                    <ng-template mdbAccordionItemHeader>
                      <i [ngClass]="nav.icon" class="fas me-3 catalog-mobile-nav-icon"></i>
                      <span class="catalog-mobile-nav">{{ nav.name }}</span>
                      <span class="badge badge-warning translate-middle badge nav-badge" *ngIf="nav.label?.text?.length > 0" [ngStyle]="{color: nav.label.textColor, background: nav.label.backgroundColor}">{{nav.label.text}}</span>
                    </ng-template>
                    <ng-template mdbAccordionItemBody>
                      <div style="max-height: calc(100vh - 200px); overflow-y: auto; padding-right: 10px;">
                      <ul class="sidenav-menu">
                        <ng-container *ngFor="let category of navbarCategories">
                          <li>
                            <a class="sidenav-link mobile-menu p-0" 
                              [href]="'/catalog/all?categories=' + category.name.toLowerCase() + '&featured=true'">
                                {{ category.name }}
                            </a>
                          </li>
                        </ng-container>
                      </ul>
                    </div>
                    </ng-template>
                  </mdb-accordion-item>
                </mdb-accordion>
                <li class="nav-item position-relative" *ngIf="nav.link != '/catalog'">
                  <span class="badge badge-warning translate-middle badge nav-badge" *ngIf="nav.label?.text?.length > 0" [ngStyle]="{color: nav.label.textColor, background: nav.label.backgroundColor}">{{nav.label.text}}</span>
                  <a class="sidenav-link" routerLinkActive="active" [routerLink]="nav.link" role="button">
                    <i [ngClass]="nav.icon" class="fas me-3 catalog-mobile-nav-icon"></i>
                    <span>{{ nav.name }}</span>
                  </a>
                </li>

              </mdb-sidenave-item>
          </ul>
        </mdb-sidenav>
        <mdb-sidenav-content #sidenavContent>
          <div class="mobile-topbar">
            <!-- Guests (e.g. live-link visitors) get logo + Login only — no sidenav -->
            <button *ngIf="authenticated" #sidenavToggle class="btn btn-link mobile-topbar__menu" (click)="sidenav.toggle()" aria-label="Open main menu">
              <i class="fas fa-bars fa-lg"></i>
            </button>
            <a class="ripple mobile-topbar__brand" href="/catalog" data-mdb-ripple-color="primary">
              <img [src]="getLogo()" class="navbar-logo" height="36" width="36" alt="Culture Studio Company Logo" loading="lazy" />
            </a>
            <div class="mobile-topbar__actions">
              <ng-container *ngIf="authenticated; else login">
                <div mdbDropdown>
                  <button class="bg-transparent float-end" type="button" id="dropdownMenuButton" aria-expanded="false"
                    mdbDropdownToggle data-mdb-display="static">
                    <i class="fas fa-user me-3" style="color: #FFF"></i>
                  </button>

                  <ul mdbDropdownMenu class="dropdown-menu navbar-user-dropdown dropdown-menu-end"
                    aria-labelledby="dropdownMenuLink">
                    <li class="profile-mobile-header"><b>Hi, {{ user.name }}!</b></li>
                    <li *ngIf="clientName" class="profile-mobile-header">Client: <span class="sidenav-client">{{ clientName }}</span></li>
                    <li>
                      <ng-container *ngIf="activeDecorator && hasMultipleClients">
                        <a class="dropdown-item" href="/login/choose-client">
                          <i class="fas fa-users-cog pe-1"></i>
                          Change Client
                        </a>
                      </ng-container>
                    </li>
                    <li>
                      <hr class="dropdown-divider" />
                    </li>
                    <li><a class="dropdown-item" (click)="logout()">
                        <i class="fas fa-sign-out-alt pe-1"></i>
                        Sign out</a></li>
                  </ul>
                </div>
              </ng-container>
            </div>
          </div>
        </mdb-sidenav-content>
      </mdb-sidenav-layout>
    </div>
  </div>
</ng-template>

<ng-template #login>
  <a class="avatar-link d-flex align-items-center" (click)="goToLogin()">Login</a>
</ng-template>

<ng-template #loginmobile>
  <div class="sidenav-mobile-login text-center">
    <a class="avatar-link d-flex align-items-center" (click)="goToLogin()">Login</a>
  </div>
</ng-template>

<ng-template #subNavCatalogMobile>
  <mdb-sidenave-item *ngFor="let nav of subNavigationCatalog">
    <mdb-accordion [flush]="true">
      <mdb-accordion-item>
        <ng-template mdbAccordionItemHeader> <i
            [ngClass]="nav.name == 'Dashboard' ? 'fas fa-home me-3' : nav.name == 'Orders' ? 'fas fa-clipboard-list me-3' : nav.name == 'Catalog' ? 'fas fa-book-open me-3' : null "></i>{{
          nav.name }}</ng-template>
        <ng-template mdbAccordionItemBody>
          <ul class="sidenav-menu">
            <a class="sidenav-link mobile-menu" tabindex="0" (click)="brandCollapse.toggle()"
              [attr.aria-expanded]="!brandCollapse.collapsed" aria-controls="collapseExample">
              <span>Brands</span><i [ngClass]="brandCollapse.collapsed ? 'fas fa-angle-down' : 'fas fa-angle-up'"></i>
            </a>
            <ul class="sidenav-collapse" mdbCollapse #brandCollapse="mdbCollapse">
              <ng-container *ngFor="let brand of brands">
                <li class="sidenav-item">
                  <a class="sidenav-link" tabindex="0" [href]="'/catalog/all?' + 'brand' + '=' + brand">{{brand}}</a>
                </li>
              </ng-container>
            </ul>
          </ul>

          <ul class="sidenav-menu">
            <a class="sidenav-link mobile-menu" tabindex="0" (click)="categoryCollapse.toggle()"
              [attr.aria-expanded]="!categoryCollapse.collapsed" aria-controls="collapseExample">
              <span>Categories</span><i
                [ngClass]="categoryCollapse.collapsed ? 'fas fa-angle-down' : 'fas fa-angle-up'"></i>
            </a>
            <ul class="sidenav-collapse" mdbCollapse #categoryCollapse="mdbCollapse">
              <ng-container *ngFor="let category of categories">
                <li class="sidenav-item">
                  <a class="sidenav-link" tabindex="0"
                    [href]="'/catalog/all?' + 'categories' + '=' + category">{{category}}</a>
                </li>
              </ng-container>
            </ul>
          </ul>

          <ul class="sidenav-menu">
            <a class="sidenav-link mobile-menu" tabindex="0" (click)="decorationCollapse.toggle()"
              [attr.aria-expanded]="!decorationCollapse.collapsed" aria-controls="collapseExample">
              <span>Decorations</span><i
                [ngClass]="decorationCollapse.collapsed ? 'fas fa-angle-down' : 'fas fa-angle-up'"></i>
            </a>
            <ul class="sidenav-collapse" mdbCollapse #decorationCollapse="mdbCollapse">
              <ng-container *ngFor="let decoration of decorations">
                <li class="sidenav-item">
                  <a class="sidenav-link" tabindex="0"
                    [href]="'/catalog/all?' + 'decoration' + '=' + decoration">{{decoration}}</a>
                </li>
              </ng-container>
            </ul>
          </ul>
        </ng-template>
      </mdb-accordion-item>
    </mdb-accordion>
  </mdb-sidenave-item>
</ng-template>

<ng-template #mobileContainer>
  <div class="mx-2">
    <content class="mobile-container">
      <router-outlet></router-outlet>
    </content>
  </div>
</ng-template>

